/* eslint-disable */
import * as utility from "./utility";
// import { batchActions } from "redux-batched-actions";
// import updateCompletions from "./updateCompletions.js";
// SYNCHRONOUS ACTIONS
export const create = utility.action("ORM_CREATE");
export const upsert = utility.action("ORM_UPSERT");
export const remove = utility.action("ORM_REMOVE");
export const noop = utility.action("NOOP");
export const addto = utility.action("ORM_ADD_TO");
export const removefrom = utility.action("ORM_REMOVE_FROM");

export const fetch_request = utility.action("FETCH_REQUEST");
export const fetch_success = utility.action("FETCH_SUCCESS");
export const fetch_failure = utility.action("FETCH_FAILURE");

// TASKS (ASYNCHRONOUS ACTIONS)
export const task_request = ({
  unprotected,
  login,
  action,
  payload,
  success
}) => async dispatch => {
  try {
    dispatch(fetch_request({ id: 0 }));
    // console.log("task_request", action, payload);
    let data = await utility.request({ unprotected, login, action, payload });
    // console.log("data: ", data);
    if (success) {
      dispatch(success(data));
      dispatch(fetch_success({ id: 0 }));
    }
  } catch (error) {
    console.error(action, payload, error);
    dispatch(fetch_failure({ id: 0 }));
  }
};



// WEBPACK FOOTER //
// ./src/actions.js